import React, { useState } from 'react';
import { useWorkspace } from '../../context/WorkspaceContext';
import { Modal } from '../../design-system/Modal';
import { Input } from '../../design-system/Input';
import { Button } from '../../design-system/Button';
import { Plus } from 'lucide-react';

export const CreateWorkspaceModal = ({ isOpen, onClose }) => {
  const { createWorkspace } = useWorkspace();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [icon, setIcon] = useState('deployed_code');
  const [error, setError] = useState('');

  const icons = ['deployed_code', 'apartment', 'sports_esports', 'memory', 'science', 'rocket_launch', 'terminal', 'palette'];

  const handleNameChange = (val) => {
    setName(val);
    if (!slug || slug === name.toLowerCase().replace(/[^a-z0-9]+/g, '-')) {
      setSlug(val.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
    }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (!name.trim()) {
      setError('Workspace name is required.');
      return;
    }

    createWorkspace({
      name: name.trim(),
      slug: slug.trim() || name.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
      icon
    });

    setName('');
    setSlug('');
    setError('');
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create New Workspace"
      subtitle="Organize distinct teams, projects, and permissions under a new workspace container"
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit} icon={<Plus size={16} />}>
            Create Workspace
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Input
          label="Workspace Name *"
          placeholder="e.g., Acme Robotics, Nexus Studio"
          value={name}
          onChange={(e) => {
            handleNameChange(e.target.value);
            if (error) setError('');
          }}
          error={error}
          autoFocus
          required
        />

        <Input
          label="Workspace URL Slug"
          placeholder="e.g., acme-robotics"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
        />

        <div>
          <div style={{ fontSize: '13px', fontWeight: '700', marginBottom: '8px', color: 'var(--text-primary)' }}>
            Choose Workspace Icon
          </div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {icons.map((ic) => (
              <button
                key={ic}
                type="button"
                onClick={() => setIcon(ic)}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: 'var(--radius-md)',
                  backgroundColor: icon === ic ? 'rgba(35, 190, 179, 0.18)' : 'var(--surface-recessed)',
                  border: icon === ic ? '2px solid var(--accent-teal)' : '1px solid var(--border-subtle)',
                  boxShadow: icon === ic ? 'var(--shadow-raised-sm)' : 'none',
                  color: icon === ic ? 'var(--accent-teal)' : 'var(--text-secondary)',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>
                  {ic}
                </span>
              </button>
            ))}
          </div>
        </div>
      </form>
    </Modal>
  );
};
